import { type FC } from "react";

import { type Filters } from "../../../utils/queryUtils";
import { FilterFormBuilder } from "../FilterFormBuilder/FilterFormBuilder";
import { getCampaignsFilters } from "./campaignsFilters";

export interface CampaignsFilterFormForPacksProps {
  filterOptions: Filters;
  updateFilter: (filter: Filters) => void;
  filter: Filters;
  onValidationChange?: (propertyName: string, isValid: boolean) => void;
}

const items = getCampaignsFilters(false);

export const CampaignsFilterFormForPacks: FC<CampaignsFilterFormForPacksProps> = ({
  filterOptions,
  filter,
  updateFilter,
  onValidationChange,
}) => (
  <FilterFormBuilder
    filterOptions={filterOptions}
    filter={filter}
    updateFilter={updateFilter}
    items={items}
    onValidationChange={onValidationChange}
  />
);
